import { useCallback, useEffect, useState } from 'react';
import { getEntertainerApplicationContract } from '../../Services/EntertainerApplicationService';
import { EntertainerApplicationContract } from './EntertainerApplicationTypes';

export default function useEntertainerApplicationContract() {
	const [contract, setContract] = useState<EntertainerApplicationContract | null>(null);
	const [error, setError] = useState<string | null>(null);
	const [attempt, setAttempt] = useState(0);

	useEffect(() => {
		const controller = new AbortController();
		setError(null);
		getEntertainerApplicationContract(controller.signal)
			.then(setContract)
			.catch((loadError: unknown) => {
				if (loadError instanceof DOMException && loadError.name === 'AbortError') return;
				setError(loadError instanceof Error ? loadError.message : 'Unable to load the application.');
			});
		return () => controller.abort();
	}, [attempt]);

	const retry = useCallback(() => setAttempt((value) => value + 1), []);
	return { contract, error, retry };
}
